export default __webpack_public_path__ + "static/media/CDC_zh.a78cc338.svg";